
export enum UserAccessPermissions {
    None = 0,
    ViewHistory = 1,
    ManageVehicles = 2,
    ManageDrivers = 4,
    ManageGeofences = 8,
    ViewMessages = 16,
    ManageJobsAndTms = 32,
    ManageGroups = 64,
    ViewVideos = 128,
    ViewJobsAndTms = 256,
    ManageAlerts = 512,
    ManageReportBuilder = 1024,
    All = ~None
}
